import React, { Component } from 'react';

class Confirmation extends Component {

  render() {
      window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/registrationConfirmationFNPage.jsp";
    return(
      <div className="container" id="confirmation">

      </div>
    )
  }
}

export default Confirmation;



// WEBPACK FOOTER //
// ./src/registration/Confirmation.js